// API URL - używa zmiennej środowiskowej lub domyślnej wartości
export const address = process.env.REACT_APP_API_URL || 'http://localhost:5001'

// Email administratora - użytkownik z tym emailem będzie przekierowany do panelu
export const adminEmail = process.env.REACT_APP_DEFAULT_USER_EMAIL || ''